export default "__VITE_ASSET__BJRrjM5u__"